/*
 * Brake House — Self-serve boot size recommender (PDP)
 * ----------------------------------------------------
 * Client-side port of the CS automation sizing engine. SOURCE OF TRUTH:
 *   Brake House CS automation/app-scripts/v7_boot_insole/Size_Recommendation_v7_FULL.gs
 *   Brake House CS automation/boot-insole-mapping/boot_insole_mapping.csv
 * The tables + logic below are copied VERBATIM from that engine (Stage A primary
 * pick + Stage B per-last insole toe-room cross-check). If a new boot launches or
 * a last changes, update BOTH the .gs (PRODUCT_LAST_MAP / BOOT_LAST_INSOLE_MM) and
 * this file. Do NOT port from BootInsole.gs (stale v6 cross-check-only version).
 *
 * Scope trim vs the .gs: the triple-standard width/girth fallback is omitted because
 * the widget collects only foot length + usual size. Everything else is faithful.
 */
(function () {
  "use strict";

  /* ============================ DATA (verbatim from .gs) ============================ */

  // Foot-length -> size lookup. Band rule: l_min < L <= l_max.
  var BOOT_MASTER_TABLE = [
    { us: 4.0,  uk: 3.0,  eu: 35.5, bh: 35, l_min: 215, l_max: 229 },
    { us: 5.0,  uk: 4.0,  eu: 37.0, bh: 36, l_min: 220, l_max: 237 },
    { us: 6.0,  uk: 5.0,  eu: 38.0, bh: 37, l_min: 229, l_max: 246 },
    { us: 6.5,  uk: 5.5,  eu: 38.5, bh: 37.5, l_min: 233, l_max: 248 }, // 2026-10-09: sold on the 3450 last only; midpoint of 6 and 7
    { us: 7.0,  uk: 6.0,  eu: 39.0, bh: 38, l_min: 237, l_max: 250 },
    { us: 7.5,  uk: 6.5,  eu: 40.0, bh: 39, l_min: 246, l_max: 254 },
    { us: 8.0,  uk: 7.0,  eu: 40.5, bh: 40, l_min: 250, l_max: 258 },
    { us: 8.5,  uk: 7.5,  eu: 41.0, bh: 40.5, l_min: 254, l_max: 262 },
    { us: 9.0,  uk: 8.0,  eu: 42.0, bh: 41, l_min: 258, l_max: 266 },
    { us: 9.5,  uk: 8.5,  eu: 42.5, bh: 41.5, l_min: 262, l_max: 271 },
    { us: 10.0, uk: 9.0,  eu: 43.0, bh: 42, l_min: 266, l_max: 275 },
    { us: 10.5, uk: 9.5,  eu: 44.0, bh: 43, l_min: 271, l_max: 279 },
    { us: 11.0, uk: 10.0, eu: 44.5, bh: 44, l_min: 275, l_max: 283 },
    { us: 11.5, uk: 10.5, eu: 45.0, bh: 44.5, l_min: 279, l_max: 288 },
    { us: 12.0, uk: 11.0, eu: 46.0, bh: 45, l_min: 283, l_max: 296 },
    { us: 13.0, uk: 12.0, eu: 47.0, bh: 46, l_min: 288, l_max: 305 },
    { us: 14.0, uk: 13.0, eu: 48.0, bh: 47, l_min: 296, l_max: 314 },
    { us: 15.0, uk: 14.0, eu: 49.5, bh: 48, l_min: 305, l_max: 320 }
  ];

  // last_code -> { BH size label : insole length (mm) }. Half-step keys (37.5 / 40.5 / 41.5 / 44.5)
  // are the half sizes, on the four ENGINEER lasts only: 34501 since 2026-10-09, 26901 / 26601 /
  // 34301 since 2026-10-11. Lengths are the workshop's figures (2026-10-10): whole size below
  // + 3.33 mm. No other last has half keys.
  var BOOT_LAST_INSOLE_MM = {
    "34301":   {35:242.0,36:248.7,37:255.4,37.5:258.7,38:262.0,39:268.7,40:275.3,40.5:278.6,41:282.0,41.5:285.3,42:288.7,43:295.3,44:302.0,44.5:305.3,45:308.6},
    "34501":   {35:245.0,36:251.7,37:258.4,37.5:261.7,38:265.0,39:271.7,40:278.3,40.5:281.6,41:285.0,41.5:288.3,42:291.7,43:298.3,44:305.0,44.5:308.3,45:311.6},
    // The 34501 in whole sizes only: the same last, for a product cut in whole sizes alone.
    "34501W":  {35:245.0,36:251.7,37:258.4,38:265.0,39:271.7,40:278.3,41:285.0,42:291.7,43:298.3,44:305.0,45:311.6},
    "26601":   {35:239.0,36:245.7,37:252.4,37.5:255.7,38:259.0,39:265.7,40:272.3,40.5:275.6,41:279.0,41.5:282.3,42:285.7,43:292.3,44:299.0,44.5:302.3,45:305.6},
    "US1101":  {35:234.0,36:240.7,37:247.4,38:254.0,39:260.7,40:267.3,41:274.0,42:280.7,43:287.3,44:294.0,45:300.6},
    "US1002":  {35:236.5,36:243.2,37:249.9,38:256.5,39:263.2,40:269.8,41:276.5,42:283.2,43:289.8,44:296.5,45:303.1},
    "27306":   {35:230.0,36:236.7,37:243.4,38:250.0,39:256.7,40:263.3,41:270.0,42:276.7,43:283.3,44:290.0,45:296.6},
    "27301-1": {35:230.0,36:236.7,37:243.4,38:250.0,39:256.7,40:263.3,41:270.0,42:276.7,43:283.3,44:290.0,45:296.6},
    "38301":   {35:235.0,36:241.7,37:248.4,38:255.0,39:261.7,40:268.3,41:275.0,42:281.7,43:288.3,44:295.0,45:301.6},
    "US1001-3":{35:236.5,36:243.2,37:249.9,38:256.5,39:263.2,40:269.8,41:276.5,42:283.2,43:289.8,44:296.5,45:303.1},
    "39002":   {35:240.0,36:246.7,37:253.4,38:260.0,39:266.7,40:273.3,41:280.0,42:286.7,43:293.3,44:300.0,45:306.6},
    "39001":   {35:240.0,36:246.7,37:253.4,38:260.0,39:266.7,40:273.3,41:280.0,42:286.7,43:293.3,44:300.0,45:306.6},
    "26901":   {35:235.04,36:241.7,37:248.36,37.5:251.7,38:255.02,39:261.68,40:268.34,40.5:271.7,41:275.0,41.5:278.3,42:281.66,43:288.32,44:294.98,44.5:298.3,45:301.64,46:308.3,47:314.96},
    "27302":   {35:230.04,36:236.7,37:243.36,38:250.02,39:256.68,40:263.34,41:270.0,42:276.66,43:283.32,44:289.98,45:296.64,46:303.3,47:309.96}
  };

  // Shopify product_id (string) -> last_code.
  var PRODUCT_LAST_MAP = {
    "9818587726137":"26901","10046238589241":"26901","10002096161081":"26901",
    "10046236950841":"26901","10175472468281":"26901","10195017367865":"26901",
    "10253062373689":"26901", // 2690 Build Your Own (2026-06-25)
    "9848511365433":"26601","10046239441209":"26601","10027865833785":"26601",
    "10046239113529":"26601","10195017531705":"26601",
    "10253076988217":"26601", // 2660 Build Your Own (2026-06-25)
    "9848477319481":"34501","10046263558457":"34501","10154571825465":"34501",
    "10131629146425":"34501","10190915207481":"34501","10191033794873":"34501","10165121155385":"34501",
    "10331405484345": "34501W",  // 3450 Maryam Horsebutt — the 34501 last, whole sizes only
    "9847921115449":"34301","10046264443193":"34301","10226728239417":"34301",
    "10253124141369":"34301", // 3530 Build Your Own (2026-06-25)
    "9850723795257":"US1101","9856696484153":"US1101","9849956335929":"US1101",
    "9850103497017":"US1002","9850733560121":"US1002","10160546808121":"US1002",
    "9850164085049":"27306","9850165428537":"27306","10153117385017":"27306",
    "9850654458169":"27301-1","10153269494073":"27301-1",
    "9850028392761":"27302","10215067484473":"27302","9850039042361":"27302",
    "9850595803449":"38301","10189415055673":"38301",
    "10051348595001":"39001",
    "10051348037945":"39002","10153158082873":"39002",
    "10051343581497":"US1001-3"
  };

  // Standalone (Size Guide page) model picker: display name -> a representative product_id
  // that maps to the model's last in PRODUCT_LAST_MAP. Lets the off-PDP widget reuse the
  // exact same engine (recommend/getBootLastCode_) with no product context of its own.
  var MODEL_OPTIONS = [
    { name: "Leather Engineer Boots 3450", pid: "9848477319481" },
    { name: "Leather Engineer Boots 3530", pid: "9847921115449" },
    { name: "Leather Engineer Boots 2660", pid: "9848511365433" },
    { name: "Leather Engineer Boots 2690", pid: "9818587726137" },
    { name: "Flat Plain Toe Service Boots 3901", pid: "10051348595001" },
    { name: "Flat Cap Toe Service Boots 3902", pid: "10051348037945" },
    { name: "American Cap Toe Work Boots 8111", pid: "9850103497017" },
    { name: "Bump Cap Toe Service Boots 8301", pid: "9850595803449" },
    { name: "Classic Moc Toe Boots 1101", pid: "9850723795257" },
    { name: "Short-face Motorcycle Boots 7301", pid: "9850654458169" },
    { name: "Two-tone Short-face Motorcycle Boots 7302", pid: "9850028392761" },
    { name: "Bear Head Work Boots 7306", pid: "9850164085049" },
    { name: "Bump Plain Toe Service Boots US1001-3", pid: "10051343581497" }
  ];

  // Manual per-last toe-target overrides (mm). Snug-cut models sized UP for more room.
  // Per-last target toe allowance (mm). EXPLICIT for every last as of 2026-09-07.
  // Keep in sync with Size_Recommendation_v7_FULL.gs and brake-house-ops/lib/boot-insole.ts.
  var BOOT_LAST_TARGET_OVERRIDE_MM = {
    "34501": 22.5, "34501W": 22.5,      // 3450 엔지니어   실측 24.7 이지만 여유↑ 일수록 반품↑ → 기존값 유지
    "34301": 21.6,      // 3530 엔지니어   실측 22.1 · 19.5 +80%(+2.6)
    "26601": 18.3,      // 2660 엔지니어   실측 18.7 · 16.5 +80%(+2.2)
    "39001": 17.5,      // 3901 플랫플레인  실측 표본 <5 → 기존값 고정
    "39002": 17.5,      // 3902 플랫캡토   실측 표본 <5 → 기존값 고정
    "US1002": 16,       // 8111 캡토워크   실측 16.5 · 14.0 +80%(+2.5)
    "38301": 14.5,      // 8301 범프캡토   실측 15.0 · 12.5 +80%(+2.5)
    "26901": 14.5,      // 2690 엔지니어   실측 15.0 · 12.3 +80%(+2.7)
    "US1001-3": 14,     // US1001-3      실측 13.2(n=5, 음수 gap) → 기존값 유지
    "27302": 12,        // 7302/7303 투톤  실측 10.3 → 유지 (재검토 대상)
    "27306": 12,        // 7306 베어헤드   실측 13.6 → 유지
    "US1101": 11.5,     // 1101 목토      실측 표본 <5 → 기존값 고정
    "27301-1": 10       // 7301 숏페이스   실측 8.5 → 12에서 10으로 하향
  };

  var BOOT_TOE_TARGET_MM = 12;     // generic fallback only
  var BOOT_TOE_TOLERANCE_MM = 5;   // how far off target before we nudge a size
  var BOOT_TOE_FLOOR_MM = 10;      // hard floor on the bottom edge of every band
  // Half sizes are PER LAST: 7.5 / 10.5 are whole BH sizes everywhere; 6.5 / 8.5 / 9.5 / 11.5 exist
  // on the four engineer lasts, built to order (34501 since 2026-10-09; 26901 / 26601 / 34301
  // since 2026-10-11). Every other half rounds UP.
  var HALF_SIZE_LASTS = ["34501", "26901", "26601", "34301"];
  var BH_ALWAYS_HALF_SIZES = [7.5, 10.5];
  var BH_MAKER_HALF_SIZES = [6.5, 8.5, 9.5, 11.5];
  function lastSellsHalfSizes_(lastCode) {
    return lastCode != null && HALF_SIZE_LASTS.indexOf(String(lastCode)) !== -1;
  }
  function offeredHalfSizes_(lastCode) {
    return lastSellsHalfSizes_(lastCode) ? BH_ALWAYS_HALF_SIZES.concat(BH_MAKER_HALF_SIZES) : BH_ALWAYS_HALF_SIZES;
  }

  /* ============================ HELPERS (ported from .gs) ============================ */

  function normalizeSizeFractions_(text) {
    return String(text || "")
      .replace(/(\d)\s*½/g, "$1.5").replace(/(\d)\s*¼/g, "$1.25").replace(/(\d)\s*¾/g, "$1.75")
      .replace(/(\d+)\s*[-\s]\s*1\/2\b/g, "$1.5")
      .replace(/(\d+)\s*[-\s]\s*1\/4\b/g, "$1.25")
      .replace(/(\d+)\s*[-\s]\s*3\/4\b/g, "$1.75");
  }

  function isNonOfferedHalf_(us, lastCode) {
    var isHalf = Math.abs((us - Math.floor(us)) - 0.5) < 1e-9;
    return isHalf && offeredHalfSizes_(lastCode).indexOf(us) === -1;
  }

  // The shopper's reported US size, mapped onto a size BH actually makes IN THIS BOOT. A half size
  // the boot doesn't come in always rounds UP -- a little room beats a squeeze, and it keeps the
  // answer consistent instead of depending on which BH bucket the half size lands in.
  function bhReferenceUs_(us, lastCode) {
    return isNonOfferedHalf_(us, lastCode) ? Math.ceil(us) : us;
  }

  function getBootLastCode_(productId) {
    if (productId == null) return null;
    return PRODUCT_LAST_MAP[String(productId).trim()] || null;
  }
  function getBootInsoleTable_(productId) {
    var last = getBootLastCode_(productId);
    return last ? (BOOT_LAST_INSOLE_MM[last] || null) : null;
  }

  // lastCode optional: with one, a half size this boot does not come in reads as the whole size
  // above it (8.5 -> BH 41 off the 3450); without one the table row is returned as-is.
  function usSizeToBhSize_(usSize, lastCode) {
    var v = parseFloat(String(usSize).replace(",", "."));
    if (isNaN(v)) return null;
    if (lastCode != null && isNonOfferedHalf_(v, lastCode)) v = Math.ceil(v);
    for (var i = 0; i < BOOT_MASTER_TABLE.length; i++) {
      if (Math.abs(Number(BOOT_MASTER_TABLE[i].us) - v) < 1e-9) return BOOT_MASTER_TABLE[i].bh;
    }
    return null;
  }
  // The sizes we actually sell (13/14 are custom-order only), per last: the 3450 adds 6.5 / 8.5 /
  // 9.5 / 11.5. Keep in sync with the engine.
  var BH_SOLD_US_SIZES_BASE = [4, 5, 6, 7, 7.5, 8, 9, 10, 10.5, 11, 12, 13, 14];
  function soldUsSizes_(lastCode) {
    if (!lastSellsHalfSizes_(lastCode)) return BH_SOLD_US_SIZES_BASE;
    return BH_SOLD_US_SIZES_BASE.concat(BH_MAKER_HALF_SIZES).sort(function (a, b) { return a - b; });
  }
  function snapToSoldUsSize_(us, lastCode) {
    var sold = soldUsSizes_(lastCode);
    var v = parseFloat(String(us).replace(',', '.'));
    if (!isFinite(v)) return us;
    if (v <= sold[0]) return sold[0];
    for (var i = 0; i < sold.length; i++) {
      if (sold[i] >= v - 1e-9) return sold[i];
    }
    return sold[sold.length - 1];
  }
  // BH -> the US size we SELL on this last. Every BH (incl. the half steps) has one US row; the
  // sold-label preference only matters for the unsold US 15 row.
  function bhToUsSize_(bh, lastCode) {
    var soldSizes = soldUsSizes_(lastCode);
    var sold = null, lowest = null;
    for (var i = 0; i < BOOT_MASTER_TABLE.length; i++) {
      if (BOOT_MASTER_TABLE[i].bh !== bh) continue;
      var us = BOOT_MASTER_TABLE[i].us;
      if (lowest == null || us < lowest) lowest = us;
      if (soldSizes.indexOf(us) !== -1 && (sold == null || us < sold)) sold = us;
    }
    var pick = sold != null ? sold : lowest;
    return pick == null ? null : String(pick);
  }
  function bhRepFootMm_(bh) {
    var lo = Infinity, hi = -Infinity;
    for (var i = 0; i < BOOT_MASTER_TABLE.length; i++) {
      if (BOOT_MASTER_TABLE[i].bh === bh) {
        if (BOOT_MASTER_TABLE[i].l_min < lo) lo = BOOT_MASTER_TABLE[i].l_min;
        if (BOOT_MASTER_TABLE[i].l_max > hi) hi = BOOT_MASTER_TABLE[i].l_max;
      }
    }
    return lo === Infinity ? null : (lo + hi) / 2;
  }
  function lastTargetToeMm_(lastCode) {
    if (lastCode == null) return null;
    if (BOOT_LAST_TARGET_OVERRIDE_MM[lastCode] != null) return BOOT_LAST_TARGET_OVERRIDE_MM[lastCode];
    var table = BOOT_LAST_INSOLE_MM[lastCode];
    if (!table) return null;
    var sum = 0, n = 0;
    Object.keys(table).forEach(function (k) {
      var bh = Number(k);
      var rep = bhRepFootMm_(bh);
      if (rep != null) { sum += (table[bh] - rep); n++; }
    });
    return n ? Math.round((sum / n) * 10) / 10 : null;
  }

  function assessBootInsoleFit_(productId, recommendedUsSize, footMm) {
    var table = getBootInsoleTable_(productId);
    if (!table) return null;
    var lastCode = getBootLastCode_(productId);
    var bh = usSizeToBhSize_(recommendedUsSize, lastCode);
    if (bh == null || table[bh] == null) return null;
    var target = lastTargetToeMm_(lastCode);
    var insole = table[bh];
    var toe = null, verdict = "unknown";
    if (footMm) {
      toe = Math.round((insole - footMm) * 10) / 10;
      var t = (target == null) ? BOOT_TOE_TARGET_MM : target;
      var lowerEdge = Math.max(t - BOOT_TOE_TOLERANCE_MM, BOOT_TOE_FLOOR_MM);
      if (toe < lowerEdge) verdict = "tight";
      else if (toe > t + BOOT_TOE_TOLERANCE_MM) verdict = "roomy";
      else verdict = "ideal";
    }
    return {
      last_code: lastCode, us_size: String(recommendedUsSize), bh_size: bh,
      insole_mm: insole, foot_mm: footMm || null, toe_room_mm: toe,
      target_mm: target, verdict: verdict
    };
  }

  // Stage B selector: among sizes with real toe room inside this last's floored band,
  // the US size closest to the anchor (usual size, else current pick); tie -> larger/roomier.
  // Wrapper: every exit below can hand back the caller's own size unchanged, which may be a
  // half we do not make (a shopper who types "9.5"). Snap on the way out so the widget can
  // only ever name a size that exists as a variant.
  function pickBootSizeInBand_(productId, footMm, refUsSize, currentUsSize) {
    var picked = pickBootSizeInBandRaw_(productId, footMm, refUsSize, currentUsSize);
    return picked == null ? picked : String(snapToSoldUsSize_(picked, getBootLastCode_(productId)));
  }
  function pickBootSizeInBandRaw_(productId, footMm, refUsSize, currentUsSize) {
    var table = getBootInsoleTable_(productId);
    if (!table || !footMm) return currentUsSize;
    var lastCode = getBootLastCode_(productId);
    var target = lastTargetToeMm_(lastCode);
    if (target == null) return currentUsSize;
    var lowerEdge = Math.max(target - BOOT_TOE_TOLERANCE_MM, BOOT_TOE_FLOOR_MM);
    var upperEdge = target + BOOT_TOE_TOLERANCE_MM;
    var acceptable = Object.keys(table).map(Number).sort(function (a, b) { return a - b; })
      .filter(function (bh) { var toe = table[bh] - footMm; return toe >= lowerEdge && toe <= upperEdge; });
    if (acceptable.length === 0) return currentUsSize;
    var anchorBh = usSizeToBhSize_(refUsSize != null ? refUsSize : currentUsSize, lastCode);
    if (anchorBh == null) return currentUsSize;
    var best = acceptable[0], bestD = Math.abs(best - anchorBh);
    acceptable.forEach(function (bh) { var d = Math.abs(bh - anchorBh); if (d <= bestD) { best = bh; bestD = d; } });
    if (currentUsSize != null && usSizeToBhSize_(currentUsSize, lastCode) === best) return currentUsSize;
    return bhToUsSize_(best, lastCode);
  }

  function computeBootDraftSize_(footMm) {
    if (!footMm) return null;
    var fitting = BOOT_MASTER_TABLE.filter(function (r) { return footMm > r.l_min && footMm < r.l_max; })
      .map(function (r) { return r.us; });
    if (fitting.length > 0) return String(Math.max.apply(null, fitting));
    if (footMm <= 215) return "4";
    if (footMm >= 320) return "15";
    return null;
  }

  /* ============================ STAGE A (ported enforceBootRulesCore_) ============================ */

  // Returns { status, us, referenceFloor }. status:
  //   'ok'         foot length consistent with usual size
  //   'too_long'   foot longer than usual-size range (draft returned + caveat)
  //   'no_ref'     no usual size given (length-only draft)
  //   'conflict'   usual size given but inconsistent (draft + caveat)
  //   'implausible' foot length outside 200-340mm
  function stageA(footMm, refText, lastCode) {
    var refTextNorm = normalizeSizeFractions_(refText || "");
    if (!footMm) return { status: "need_length", us: null, referenceFloor: null };
    if (footMm < 200 || footMm > 340) return { status: "implausible", us: null, referenceFloor: null };

    var allNumbers = refTextNorm.match(/\d+([.,]\d+)?/g);
    var matchedIndices = [];
    var referenceFloor = null;

    if (allNumbers) {
      var uniqueNums = allNumbers.map(function (n) { return parseFloat(n.replace(",", ".")); })
        .filter(function (v, i, a) { return a.indexOf(v) === i; });
      var isExplicitlyNonUS = /UK|EU|EURO/i.test(refText || "");
      uniqueNums.forEach(function (val) {
        BOOT_MASTER_TABLE.forEach(function (row, i) {
          if (isExplicitlyNonUS) {
            if (row.us === val || row.uk === val || row.eu === val) matchedIndices.push(i);
          } else {
            if (row.us === val) matchedIndices.push(i);
          }
        });
      });
    }
    matchedIndices = matchedIndices.filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });

    if (matchedIndices.length > 0) {
      var anchorRefUs = Math.max.apply(null, matchedIndices.map(function (i) { return BOOT_MASTER_TABLE[i].us; }));
      if (isNonOfferedHalf_(anchorRefUs, lastCode)) referenceFloor = Math.ceil(anchorRefUs);
    }

    // Cluster adjacent indices; keep the largest cluster.
    if (matchedIndices.length > 0) {
      var clusters = [];
      var cur = [matchedIndices[0]];
      for (var i = 1; i < matchedIndices.length; i++) {
        if (matchedIndices[i] - matchedIndices[i - 1] <= 1) cur.push(matchedIndices[i]);
        else { clusters.push(cur); cur = [matchedIndices[i]]; }
      }
      clusters.push(cur);
      matchedIndices = clusters.reduce(function (p, c) { return p.length >= c.length ? p : c; });
    }

    var isConsistent = matchedIndices.length > 0;
    if (matchedIndices.length > 1) {
      for (var k = 0; k < matchedIndices.length - 1; k++) {
        if (matchedIndices[k + 1] - matchedIndices[k] > 1) { isConsistent = false; break; }
      }
    }

    if (isConsistent) {
      var minIdx = matchedIndices[0];
      var maxIdx = matchedIndices[matchedIndices.length - 1];
      if (footMm > BOOT_MASTER_TABLE[minIdx].l_min && footMm <= BOOT_MASTER_TABLE[maxIdx].l_max) {
        var candidates = BOOT_MASTER_TABLE.filter(function (r) { return footMm > r.l_min && footMm <= r.l_max; });
        var finalRow = candidates.filter(function (c) { return matchedIndices.indexOf(BOOT_MASTER_TABLE.indexOf(c)) !== -1; })[0]
          || candidates[candidates.length - 1];
        return { status: "ok", us: String(finalRow.us), referenceFloor: referenceFloor };
      } else if (footMm > BOOT_MASTER_TABLE[maxIdx].l_max) {
        return { status: "too_long", us: computeBootDraftSize_(footMm), referenceFloor: referenceFloor };
      }
    }

    // No triple-standard fallback (widget collects only length + usual size).
    var draft = computeBootDraftSize_(footMm);
    if (matchedIndices.length === 0) return { status: "no_ref", us: draft, referenceFloor: referenceFloor };
    return { status: "conflict", us: draft, referenceFloor: referenceFloor };
  }

  /* ============================ PUBLIC: recommend() ============================ */

  // Parse the customer's usual size from free text (mirrors the Stage B anchor parse in the .gs):
  // largest number that is a valid US boot size, else null. Half sizes the master table doesn't
  // carry (5.5/6.5/12.5) are kept too -- they are real sizes a shopper can wear, and dropping them
  // used to blank the whole widget. bhReferenceUs_ rounds them onto a size we make.
  function parseRefUs(usualText) {
    var refNums = String(usualText || "").match(/\d+([.,]\d+)?/g);
    if (!refNums) return null;
    var vals = refNums.map(function (n) { return parseFloat(n.replace(",", ".")); })
      .filter(function (v) {
        return !isNaN(v) && (usSizeToBhSize_(v) != null || usSizeToBhSize_(bhReferenceUs_(v, null)) != null);
      });
    return vals.length ? Math.max.apply(null, vals) : null;
  }

  // { status, engineUs, refUs, fit } — fit = assessBootInsoleFit_ on the final engine size (may be null).
  function recommend(footMm, usualText, productId) {
    var refUs = parseRefUs(usualText);
    var a = stageA(footMm, usualText, getBootLastCode_(productId));
    if (a.status === "implausible" || a.status === "need_length") {
      return { status: a.status, engineUs: null, refUs: refUs, fit: null };
    }
    var us = a.us;
    // Half-size reference floor (applyHalfSizeReferenceFloor_).
    if (us != null && a.referenceFloor != null) {
      var curF = parseFloat(us);
      if (isFinite(curF) && a.referenceFloor > curF) us = String(a.referenceFloor);
    }
    // Stage B insole cross-check (applyBootInsoleCrossCheck_), anchored on usual size.
    if (us != null && footMm) {
      var table = getBootInsoleTable_(productId);
      var target = lastTargetToeMm_(getBootLastCode_(productId));
      if (table && target != null) {
        var chosen = pickBootSizeInBand_(productId, footMm, refUs, us);
        if (chosen != null) us = String(chosen);
      }
    }
    return { status: a.status, engineUs: us, refUs: refUs, fit: assessBootInsoleFit_(productId, us, footMm) };
  }

  // Per-last qualitative fit tier for shopper-facing copy (derived from the per-last toe targets;
  // NEVER expose the underlying insole/toe-room mm on the storefront — vendor constraint).
  var LAST_FIT_TIER = {
    "US1101": "snug", "26901": "snug", "27302": "snug", "27301-1": "snug", "27306": "snug", "38301": "snug",
    "US1002": "standard", "US1001-3": "standard", "26601": "standard", "39001": "standard", "39002": "standard",
    "34501": "roomy", "34301": "roomy"
  };
  var LAST_MODEL_NAME = {
    "34501": "3450", "34301": "3530", "26601": "2660", "26901": "2690",
    "US1101": "1101", "US1002": "8111", "US1001-3": "US1001-3", "38301": "8301",
    "39001": "3901", "39002": "3902", "27306": "7306", "27301-1": "7301", "27302": "7302"
  };
  function modelFitSentence(lastCode) {
    var name = LAST_MODEL_NAME[lastCode];
    var tier = LAST_FIT_TIER[lastCode];
    if (!name || !tier || tier === "standard") return "";
    if (tier === "snug") return "The " + name + " is cut close to the foot.";
    return "The " + name + " has a longer toe box.";
  }

  /* ============================ UI WIRING ============================ */

  // Unit-aware length normalization, mirroring the .gs: cm→mm = round(cm*10); in→mm = round(in*25.4).
  function toMm(val, unit) {
    var n = parseFloat(String(val).replace(",", "."));
    if (isNaN(n)) return null;
    return unit === "in" ? Math.round(n * 25.4) : Math.round(n * 10);
  }

  var UNIT_CFG = {
    cm: { placeholder: "e.g. 27.0", min: "20", max: "34", range: "20-34 cm" },
    in: { placeholder: "e.g. 10.6", min: "7.9", max: "13.4", range: "8-13.4 in" }
  };

  // Find the Size variant control on the PDP. Prefer chip buttons (chip mode is the real
  // interactive UI: clicking updates both the selected variant AND the highlighted chip);
  // fall back to a native <select> only when the product has no chips.
  function findSizeControl(root) {
    var scope = document.querySelector('[data-wair-option-name="Size"]') || document;
    var chips = scope.querySelectorAll("button.dynamic-variant-button[data-option-value], button.product__chip[data-option-value]");
    if (chips.length) return { type: "chips", els: Array.prototype.slice.call(chips) };
    var select = scope.querySelector('select[name^="options"], select.dynamic-variant-input');
    if (select) return { type: "select", el: select };
    return null;
  }

  // Read available size option values from the control, with parsed number + BH.
  function readSizeOptions(control) {
    var out = [];
    if (!control) return out;
    if (control.type === "select") {
      Array.prototype.slice.call(control.el.options).forEach(function (o) {
        var num = parseFloat(String(o.value).replace(",", "."));
        if (!isNaN(num)) out.push({ value: o.value, num: num, bh: usSizeToBhSize_(num) });
      });
    } else {
      control.els.forEach(function (b) {
        var v = b.getAttribute("data-option-value") || b.textContent.trim();
        var num = parseFloat(String(v).replace(",", "."));
        if (!isNaN(num)) out.push({ value: v, num: num, bh: usSizeToBhSize_(num), el: b });
      });
    }
    return out;
  }

  // Snap the engine US size to an actual buyable option value. BH-aware:
  // 1) exact US number, 2) same BH (closest num, tie->larger), 3) nearest num (tie->larger).
  function snapToOption(engineUs, options) {
    if (!options.length) return null;
    var target = parseFloat(String(engineUs).replace(",", "."));
    if (isNaN(target)) return null;
    var exact = options.filter(function (o) { return Math.abs(o.num - target) < 1e-9; });
    if (exact.length) return exact[0];
    var targetBh = usSizeToBhSize_(target);
    function nearest(list) {
      var best = null, bestD = Infinity;
      list.forEach(function (o) {
        var d = Math.abs(o.num - target);
        if (d < bestD || (d === bestD && best && o.num > best.num)) { best = o; bestD = d; }
      });
      return best;
    }
    if (targetBh != null) {
      var sameBh = options.filter(function (o) { return o.bh === targetBh; });
      if (sameBh.length) return nearest(sameBh);
    }
    return nearest(options);
  }

  function applySelection(control, option) {
    if (!control || !option) return;
    if (control.type === "select") {
      control.el.value = option.value;
      control.el.dispatchEvent(new Event("change", { bubbles: true }));
    } else if (option.el) {
      option.el.click();
    }
  }

  function init(root) {
    var productId = root.getAttribute("data-product-id");
    // Standalone (Size Guide) mode: the shopper picks the model, there is no product context
    // or size chips. A model <select> supplies the product_id that drives the same engine.
    var standalone = root.hasAttribute("data-bhsr-standalone");
    // Korean storefront: Korean copy, start in cm.
    var KO = /^ko/i.test(document.documentElement.lang || "");
    function T(en, ko) { return KO ? ko : en; }
    var modelSelect = root.querySelector("[data-bhsr-model]");
    if (modelSelect && !modelSelect.getAttribute("data-bhsr-filled")) {
      MODEL_OPTIONS.forEach(function (m) {
        var o = document.createElement("option");
        o.value = m.pid;
        o.textContent = m.name;
        modelSelect.appendChild(o);
      });
      modelSelect.setAttribute("data-bhsr-filled", "1");
    }
    function currentProductId() { return modelSelect ? (modelSelect.value || null) : productId; }

    // Boot gate: PDP mode hides itself for products with no insole data. Standalone always shows.
    if (!standalone && !getBootLastCode_(productId)) { root.style.display = "none"; return; }

    // Relocate the standalone widget to sit right under a target heading (e.g. #boot-sizing)
    // that lives elsewhere in the rendered page body.
    var relSel = root.getAttribute("data-bhsr-relocate");
    if (relSel) {
      var anchor = document.querySelector(relSel);
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(root, anchor.nextSibling);
    }

    var lenInput = root.querySelector("[data-bhsr-length]");
    var usualSelect = root.querySelector("[data-bhsr-usual]");
    var resultEl = root.querySelector("[data-bhsr-result]");
    if (!lenInput || !resultEl) return;

    // cm/inch unit toggle (default inch — primary market measures in inches).
    var unit = "in";
    var unitBtns = Array.prototype.slice.call(root.querySelectorAll("[data-bhsr-unit]"));
    function setUnit(u) {
      if (!UNIT_CFG[u]) return;
      unit = u;
      unitBtns.forEach(function (b) {
        var active = b.getAttribute("data-bhsr-unit") === u;
        b.classList.toggle("is-active", active);
        b.setAttribute("aria-pressed", active ? "true" : "false");
      });
      lenInput.placeholder = KO ? UNIT_CFG[u].placeholder.replace("e.g.", "예:") : UNIT_CFG[u].placeholder;
      lenInput.min = UNIT_CFG[u].min;
      lenInput.max = UNIT_CFG[u].max;
      run();
    }
    unitBtns.forEach(function (b) {
      b.addEventListener("click", function () { setUnit(b.getAttribute("data-bhsr-unit")); });
    });
    if (KO) setUnit("cm");

    // Recommendation heading (we frame the result as OUR recommendation, not a restatement of
    // the shopper's own pick). When the usual size isn't a buyable option on this product
    // (e.g. 9.5 on a boot that only sells 10), name the closest size we actually make.
    function recommendHeading(refUs, snap) {
      if (snap && Math.abs(snap.num - refUs) > 1e-9) {
        return KO ? "추천 사이즈는 <strong>US " + snap.value + "</strong>입니다. 평소 신으시는 US " + refUs + "에 가장 가까운 저희 사이즈입니다." : "We recommend <strong>US " + snap.value + "</strong>, the closest size we make to your usual US " + refUs + ".";
      }
      return KO ? "추천 사이즈는 <strong>US " + (snap ? snap.value : refUs) + "</strong>입니다." : "We recommend <strong>US " + (snap ? snap.value : refUs) + "</strong>.";
    }
    // "shorter" / "longer": is the measurement-based size below or above the usual size.
    function footDir(recNum, refNum) {
      return recNum < refNum ? "shorter" : "longer";
    }
    // Confidence line: ties the model's fit character + the shopper's foot length into a
    // "should fit well" reassurance (only used where we have a measurement and a confident pick).
    function fitsWell(lastCode, shownUs) {
      var known = LAST_MODEL_NAME[lastCode];
      if (KO) return (known || "이 부츠") + "의 핏과 발 길이를 함께 보면 US " + shownUs + " 사이즈가 잘 맞으실 겁니다.";
      return "Considering " + (known ? "the " + known : "this boot") + "'s fit and your foot length, US " + shownUs + " should suit you well.";
    }

    // Persist the shopper's stated sizing onto the cart line so it lands on the order for CS.
    // PDP mode only (the Size Guide standalone widget has no cart form). The property keys are
    // underscore-prefixed so they stay hidden from the customer-facing order confirmation, matching
    // the BSS customization options. An empty value removes the input so we never create a blank
    // property (e.g. "Not sure" usual size, or a cleared foot-length field).
    function setCartProp_(form, key, value) {
      var input = form.querySelector('input[data-bhsr-prop="' + key + '"]');
      if (!value) { if (input && input.parentNode) input.parentNode.removeChild(input); return; }
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[" + key + "]";
        input.setAttribute("data-bhsr-prop", key);
        form.appendChild(input);
      }
      input.value = value;
    }
    function syncCartProps_() {
      if (standalone) return;
      var form = root.closest('form[action*="/cart"]') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      // Only a real (numeric) usual size is stored; "Not sure" clears it.
      var usualVal = (usualSelect && parseRefUs(usualSelect.value) != null) ? usualSelect.value : "";
      var lenVal = lenInput.value ? (lenInput.value + " " + unit) : "";
      setCartProp_(form, "_usual_size", usualVal);
      setCartProp_(form, "_foot_length", lenVal);
      // Clear the recommendation outcome each run; a confident case below re-sets it via recOut_.
      setCartProp_(form, "_recommended_size", "");
      setCartProp_(form, "_fit_check", "");
    }
    // Records the widget's own initial judgment onto the cart line so CS can spot a clearly-wrong
    // ordered size at a glance (e.g. measured 28cm / usual 10 but ordered 8). size = recommended
    // US; verdict = short qualitative status. NEVER include insole/toe-room mm (vendor constraint).
    function recOut_(size, verdict) {
      if (standalone) return;
      var form = root.closest('form[action*="/cart"]') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      setCartProp_(form, "_recommended_size", size ? String(size) : "");
      setCartProp_(form, "_fit_check", verdict || "");
    }

    // Case matrix (confirmed 2026-07-07). All copy is qualitative — NEVER print insole or
    // toe-room mm (vendor does not want internal-length data public). Gap is measured in BH
    // steps (uniform), not US numbers.
    //   1  no foot length + usual size   -> set usual size; measure after ordering, contact CS
    //   2  implausible foot length       -> re-measure warning, no selection
    //   3  foot length only ("Not sure") -> engine pick, select, invite usual size
    //   4  gap 0                          -> aligned, select
    //   5  gap 1 (either direction)       -> set USUAL size; re-measure + consult CS
    //   6  gap >= 2                       -> hold selection, strong re-measure prompt
    function run() {
      // Keep the cart-line properties in sync on every change (runs before any early return).
      syncCartProps_();
      // Standalone: wait for a model choice before recommending anything.
      if (standalone && !currentProductId()) {
        resultEl.className = "bhsr__result";
        resultEl.innerHTML = "";
        return;
      }
      var usualText = usualSelect ? (usualSelect.value || "") : "";
      var refUs = parseRefUs(usualText);
      var lastCode = getBootLastCode_(currentProductId());
      var control = findSizeControl(root);
      var options = readSizeOptions(control);
      var lines = [];

      // --- Case 1: no foot length, usual size chosen -> provisional usual-size pick.
      if (lenInput.value === "") {
        if (refUs == null) {
          resultEl.className = "bhsr__result";
          resultEl.innerHTML = "";
          return;
        }
        var refBhUs = bhReferenceUs_(refUs, lastCode);
        var usualSnap = snapToOption(refBhUs, options);
        lines.push('<div class="bhsr__size">' + recommendHeading(refUs, usualSnap) + "</div>");
        if (refBhUs !== refUs) {
          lines.push(KO
            ? '<div class="bhsr__note">이 부츠는 US ' + refUs + " 사이즈를 만들지 않아, 아래가 아닌 위인 US " + refBhUs + " 사이즈로 올렸습니다. 약간의 여유는 신기 편하지만 반 사이즈 작은 건 힘듭니다. 반올림한 값이니 위에 발 길이를 더해 주시면 핏을 다시 확인해 드립니다.</div>"
            : '<div class="bhsr__note">We don\'t make a US ' + refUs + " in this boot, so we go up to US " + refBhUs + " rather than down. A little room is easy to live with; half a size too tight is not. Because we've rounded, it's worth measuring your foot and adding the length above so we can double-check the fit for you.</div>");
        } else {
          lines.push(KO
            ? '<div class="bhsr__note">저희 부츠는 정사이즈에 가깝습니다. 평소 신는 사이즈가 US ' + refUs + "인 경우 여기서도 그 사이즈를 권합니다. 다만 브랜드와 모델마다 핏이 달라, 위에 발 길이를 더해 주시면 다시 확인해 드립니다.</div>"
            : '<div class="bhsr__note">Our boots run close to true size, so if you usually wear US ' + refUs + ", we\'d go with your usual size here. Fit can vary by brand and model, though, so add your foot length above and we\'ll double-check it for you.</div>");
        }
        resultEl.className = "bhsr__result bhsr__result--ok";
        resultEl.innerHTML = lines.join("");
        applySelection(control, usualSnap);
        recOut_(usualSnap ? usualSnap.value : refUs, "usual size only, no foot length");
        return;
      }

      var footMm = toMm(lenInput.value, unit);
      if (footMm == null) {
        resultEl.className = "bhsr__result";
        resultEl.innerHTML = "";
        return;
      }

      // Feed the engine the rounded reference so its own half-size floor sees a size we make
      // (a raw 5.5/6.5/12.5 matches no master-table row and would silently drop the anchor).
      var rec = recommend(footMm, (refUs != null ? String(bhReferenceUs_(refUs, lastCode)) : usualText), currentProductId());

      // --- Case 2: implausible measurement.
      if (rec.status === "implausible") {
        resultEl.className = "bhsr__result bhsr__result--warn";
        resultEl.innerHTML = KO
          ? "입력하신 길이가 맞지 않는 것 같습니다(보통 " + UNIT_CFG[unit].range + " 범위). 부츠와 함께 신을 양말을 신고 양발에 체중을 고르게 실은 채 서서 뒤꿈치부터 발끝까지 다시 재 주세요(앉아서 재지 마세요)."
          : "That length looks off (we expect roughly " + UNIT_CFG[unit].range + "). Please re-measure standing, heel to toe, with your weight even on both feet and the socks you\'ll wear with the boots (do not measure sitting down).";
        recOut_("", "re-measure: length looks off");
        return;
      }
      if (!rec.engineUs) {
        resultEl.className = "bhsr__result";
        resultEl.innerHTML = "";
        return;
      }

      var snapped = snapToOption(rec.engineUs, options);
      var shownUs = snapped ? snapped.value : rec.engineUs;
      var recBh = usSizeToBhSize_(snapped ? snapped.num : rec.engineUs, lastCode);

      // --- Case 3: foot length only.
      if (refUs == null) {
        lines.push('<div class="bhsr__size">' + T("We recommend <strong>US " + shownUs + "</strong>.", "추천 사이즈는 <strong>US " + shownUs + "</strong>입니다.") + "</div>");
        lines.push('<div class="bhsr__note">' + fitsWell(lastCode, shownUs) + "</div>");
        lines.push('<div class="bhsr__note bhsr__note--soft">' + T("Add your usual size above and we\'ll cross-check it against how you normally fit.", "위에 평소 사이즈를 더해 주시면 평소 핏과 교차 확인해 드립니다.") + '</div>');
        resultEl.className = "bhsr__result bhsr__result--ok";
        resultEl.innerHTML = lines.join("");
        applySelection(control, snapped);
        recOut_(shownUs, "by foot length, no usual size");
        return;
      }

      // Compare on the size we'd actually sell this shopper, so a half size we don't make still
      // yields a real BH reference instead of a null gap (which fell through to the Case 6 warning).
      var refBh = usSizeToBhSize_(bhReferenceUs_(refUs, lastCode), lastCode);
      var gap = (refBh != null && recBh != null) ? Math.abs(refBh - recBh) : null;

      // --- Case 4: aligned.
      if (gap === 0) {
        lines.push('<div class="bhsr__size">' + T("We recommend <strong>US " + shownUs + "</strong>.", "추천 사이즈는 <strong>US " + shownUs + "</strong>입니다.") + "</div>");
        lines.push('<div class="bhsr__note">' + T("Your usual size and your foot length both point here, so US " + shownUs + " should suit you well.", "평소 사이즈와 발 길이가 모두 여기를 가리키니 US " + shownUs + " 사이즈가 잘 맞으실 겁니다.") + "</div>");
        resultEl.className = "bhsr__result bhsr__result--ok";
        resultEl.innerHTML = lines.join("");
        applySelection(control, snapped);
        recOut_(shownUs, "aligned: usual and length agree");
        return;
      }

      // --- Case 5: one step apart -> keep the customer's usual size, route to CS.
      if (gap === 1) {
        var usualSnap5 = snapToOption(bhReferenceUs_(refUs, lastCode), options);
        var recNum5 = snapped ? snapped.num : parseFloat(String(rec.engineUs).replace(",", "."));
        var dir5 = footDir(recNum5, refUs);
        var keptUs = usualSnap5 ? usualSnap5.value : refUs;
        lines.push('<div class="bhsr__size">' + recommendHeading(refUs, usualSnap5) + "</div>");
        lines.push(KO
          ? '<div class="bhsr__note">저희 부츠는 정사이즈에 가까워 보통은 평소 신으시는 US ' + refUs + " 사이즈를 권합니다. 다만 발 길이는 조금 더 " + (dir5 === "shorter" ? "짧게" : "길게") + " 나와 US " + shownUs + "에 가깝습니다. 두 값이 가까우니 US " + keptUs + "도 괜찮을 겁니다. 확실히 하시려면 아래 안내대로 다시 재신 뒤 고객센터로 문의해 주세요. 가장 잘 맞는 사이즈를 확인해 드립니다.</div>"
          : '<div class="bhsr__note">Our boots run close to true size, so we\'d normally suggest your usual US ' + refUs + ". Your foot length, though, comes out a little " + dir5 + ", closer to US " + shownUs + ". The two are close, so US " + keptUs + " should still work. To be sure, please re-measure using the guide below and contact our customer center and we\'ll confirm the best fit.</div>");
        resultEl.className = "bhsr__result bhsr__result--ok";
        resultEl.innerHTML = lines.join("");
        applySelection(control, usualSnap5);
        recOut_(keptUs, "1 step off: usual " + refUs + " vs length " + shownUs);
        return;
      }

      // --- Case 6: two or more steps apart -> hold selection, ask for a re-measure.
      var recNum6 = snapped ? snapped.num : parseFloat(String(rec.engineUs).replace(",", "."));
      var dir6 = footDir(recNum6, refUs);
      lines.push('<div class="bhsr__size">' + T("Let\'s double-check your measurement.", "입력하신 측정값을 다시 확인해 주세요.") + '</div>');
      lines.push(KO
        ? '<div class="bhsr__note">평소 사이즈(US ' + refUs + ")와 발 길이가 꽤 다른 사이즈를 가리킵니다. 측정값은 훨씬 " + (dir6 === "shorter" ? "짧게" : "길게") + " 나와 US " + shownUs + " 근처입니다. 보통 앉아서 쟀거나 단위(cm/인치)가 뒤바뀐 경우입니다. 부츠와 함께 신을 양말을 신고 서서 다시 재 주세요.</div>"
        : '<div class="bhsr__note">Your usual US ' + refUs + " and your foot length point to quite different sizes. Your measurement comes out much " + dir6 + ", around US " + shownUs + ". This usually happens when the foot is measured sitting down, or the unit (cm/inch) is mixed up. Please re-measure standing, wearing the socks you\'ll wear with the boots.</div>");
      lines.push('<div class="bhsr__note bhsr__note--soft">' + T("On foot length alone, US " + shownUs + " looks right, but please re-measure first.", "발 길이만 보면 US " + shownUs + " 사이즈가 맞아 보이지만 먼저 다시 재 주세요.") + "</div>");
      resultEl.className = "bhsr__result bhsr__result--warn";
      resultEl.innerHTML = lines.join("");
      recOut_(shownUs, "MISMATCH: usual " + refUs + " vs length " + shownUs);
      // No auto-select in this case.
    }

    lenInput.addEventListener("input", run);
    lenInput.addEventListener("change", run);
    if (usualSelect) usualSelect.addEventListener("change", run);
    if (modelSelect) modelSelect.addEventListener("change", run);
  }

  function boot() {
    var roots = document.querySelectorAll("[data-bhsr-root]");
    Array.prototype.forEach.call(roots, function (r) {
      if (r.getAttribute("data-bhsr-ready")) return;
      r.setAttribute("data-bhsr-ready", "1");
      init(r);
    });
  }

  // Expose the pure engine for QA/console spot-checks (harmless, no DOM side effects).
  if (typeof window !== "undefined") {
    window.BHSizeRecommender = {
      recommend: recommend,
      assess: assessBootInsoleFit_,
      parseRefUs: parseRefUs,
      usToBh: usSizeToBhSize_
    };
  }

  if (typeof document !== "undefined" && document.addEventListener) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }
    // Re-init after theme section re-renders (theme editor / dynamic sections).
    document.addEventListener("shopify:section:load", boot);
  }
})();
